import { ChangeDetectionStrategy, Component, computed, effect, inject, input, model, viewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { PAGE } from '../../app.routes';
import { GenderEnum, SearchFields, SearchPatientCaseResult } from '../../core';
import { BaseComponent, ConvertDatePipe, SortableHeaderComponent, SortEvent } from '../../shared';
import { PlanTableComponent } from '../plan-table';


/**
 * Component for table of Patients.
 */
@Component({
	selector: 'tsp-patient-table',
	imports: [
		ConvertDatePipe,
		NgbCollapseModule,
		PlanTableComponent,
		SortableHeaderComponent
	],
	templateUrl: './patient-table.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PatientTableComponent extends BaseComponent {

	private readonly router = inject(Router);

	hasPlanDetails = input(false);
	isFiltersCollapsed = input(false);
	patients = input<(SearchPatientCaseResult & { opened?: boolean })[]>([]);
	sortOrder = model<SortEvent>();

	activeColumn = computed(() => this.sortOrder()?.column);
	fields = SearchFields;

	private readonly _headers = viewChildren(SortableHeaderComponent);


	protected _updateHeadersDirection = effect(() => {
		this._headers().forEach(h => h.direction.set(''));
		this._headers().find(h => h.name() === this.sortOrder()?.column)?.direction.set(this.sortOrder()?.direction ?? '');
	});

	/**
	* Update column sort order and sort list.
	*/
	onSort({ column, direction }: SortEvent) {
		this.sortOrder.set({ column, direction });
	}

	/** 
	 * Get css class according to gender.
	*/
	genderClass(gender: GenderEnum): string {
		switch (gender) {
			case GenderEnum.FEMALE: return 'f';
			case GenderEnum.MALE: return 'm';
			case GenderEnum.OTHER: return 'o';
			default: return '';
		}
	}

	/**
	 * Navigate to patient settings edit page.
	 */
	patientSettings(patientGuid: string): void {
		this.router.navigate([PAGE.PATIENT_SETTINGS], { queryParams: { patientGuid: patientGuid } });
	}

	/**
	 * Navigate to patient history page.
	 */
	patientHistory(patientGuid: string): void {
		this.router.navigate([PAGE.PATIENT_HISTORY], { queryParams: { patientGuid: patientGuid } });
	}

}
